import React from 'react';
import { useNavigate } from 'react-router-dom';

const SuccessPayment = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/profile');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="flex items-center justify-center w-16 h-16 mb-4 bg-green-500 rounded-full">
        <svg
          className="w-8 h-8 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          ></path>
        </svg>
      </div>
      <h1 className="mb-4 text-2xl font-bold text-black">Payment Successful!</h1>
      <p className="mb-2 text-lg text-gray-700">
        Your payment has been processed successfully.
      </p>
      <p className="mb-10 text-lg text-gray-700">
        Have a great day!
      </p>
      <button
        onClick={handleButtonClick}
        className="px-4 py-2 font-bold text-white bg-pink-600 rounded hover:bg-pink-700 focus:outline-none focus:shadow-outline"
      >
        Go Back to Dashboard to Download Your File
      </button>
    </div>
  );
};

export default SuccessPayment;
